import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["children", "icon", "iconTheme", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base, Text } from '../../components/Base';
import Svg from '../../components/Svg';
var styles = {
  "root": "TitleCell-root_1gapG",
  "iconWrapper": "TitleCell-iconWrapper_2jco9",
  "icon": "TitleCell-icon_2DTd5"
};
function TitleCell(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    _ref$iconTheme = _ref.iconTheme,
    iconTheme = _ref$iconTheme === void 0 ? 'anthracite' : _ref$iconTheme,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      flex: true,
      flexGrow1: true,
      paddingY: "xsmall",
      paddingX: "small",
      flexAlignItemsCenter: true,
      className: clsx(styles.root, className)
    }, extraProps), /*#__PURE__*/React.createElement(Base, {
      tagName: "h3",
      flex: true,
      flexAlignItemsStart: true,
      margin: "none",
      size: "big",
      weight: "semibold"
    }, icon && /*#__PURE__*/React.createElement(Base, {
      flex: true,
      flexShrink0: true,
      flexAlignItemsCenter: true,
      className: styles.iconWrapper
    }, /*#__PURE__*/React.createElement(Svg, {
      name: icon,
      theme: iconTheme,
      className: styles.icon
    })), /*#__PURE__*/React.createElement(Text, null, children)))
  );
}
export default TitleCell;